var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtendimentoFinalizado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.05536 8.21622C5.77898 7.91473 5.30161 7.88957 5.00008 8.16596C4.69859 8.44234 4.67344 8.91971 4.94982 9.22124L8.7438 13.3419C8.89457 13.4926 9.07045 13.5931 9.27142 13.5931C9.27142 13.5931 9.27142 13.5931 9.29653 13.5931C9.49755 13.5931 9.69853 13.5177 9.82415 13.367L19.4222 3.7941C19.7237 3.49261 19.7237 3.0152 19.4222 2.73881C19.1207 2.43732 18.6433 2.43732 18.3669 2.73881L9.32173 11.7589L6.05536 8.21622Z",
    fill: "#30D158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2463 9.24624C18.8191 9.24624 18.4925 9.57288 18.4925 9.99999C18.4925 14.6733 14.6734 18.4925 10 18.4925C5.32663 18.4925 1.50754 14.6734 1.50754 10C1.50754 5.32668 5.32663 1.50754 10 1.50754C10.4272 1.50754 10.7538 1.1809 10.7538 0.753796C10.7538 0.32669 10.4271 0 10 0C4.49748 0 0 4.49748 0 10C0 15.5026 4.49748 20.0001 10 20.0001C15.5026 20.0001 20.0001 15.5026 20.0001 10C20 9.57288 19.6734 9.24624 19.2463 9.24624Z",
    fill: "#30D158"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtendimentoFinalizado);
export default __webpack_public_path__ + "static/media/atendimento-finalizado.29884546.svg";
export { ForwardRef as ReactComponent };